import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AccessibleContent from '../../utils/AccessibleContent';

const PromoBanner = ({ store, lang }) => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  const teaser = store.discount?.teaser?.[lang] || '';
  const plainText = teaser.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();

  if (dismissed || !plainText) return null;

  return (
    <div className="promoBanner" role="status">
      <AccessibleContent className="promoBannerText" htmlContent={teaser} />
      <button
        type="button"
        className="promoBannerClose"
        onClick={() => setDismissed(true)}
        aria-label={t('Fermer')}
      >
        &times;
      </button>
    </div>
  );
};

PromoBanner.propTypes = {
  store: PropTypes.object.isRequired,
  lang: PropTypes.string
};

export default PromoBanner;
